import React from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';
import cn from 'classnames';
import detectIt from 'detect-it';
import theme, { buttonReset } from '../../styles/theme';

const Button = ({
  children, classes, className, onClick, text, selected,
  largePadding,
}) => (
  <button
    key={text}
    className={cn(className, classes.button, selected && classes.selected, { largePadding })}
    onClick={onClick}
    type="button"
  >
    {text}
    {children}
  </button>
);

Button.propTypes = {
  children: PropTypes.any, // eslint-disable-line react/forbid-prop-types
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  className: PropTypes.string,
  onClick: PropTypes.func,
  text: PropTypes.string.isRequired,
  selected: PropTypes.bool,
  // eslint-disable-next-line react/no-unused-prop-types
  buttonTheme: PropTypes.shape({
    color: PropTypes.string.isRequired,
    selected: PropTypes.string.isRequired,
  }),
  largePadding: PropTypes.bool,
};

Button.defaultProps = {
  children: undefined,
  className: undefined,
  onClick: undefined,
  selected: false,
  buttonTheme: {
    color: theme.colors.inactiveBtn,
    selected: theme.colors.brand01,
  },
  largePadding: false,
};

export default injectSheet({
  button: {
    position: 'relative',
    '&::after': {
      content: '""',
      position: 'absolute',
      left: 8,
      right: 8,
      bottom: '-2px',
      transition: 'border-color 0.2s ease-out',
      zIndex: 1,
    },
    ...buttonReset({
      fontFamily: theme.fonts.bold,
      fontWeight: theme.fonts.boldWeight,
      fontSize: 16,
      letterSpacing: 2.3,
      lineHeight: '28px',
      marginBottom: 2,
      padding: 8,
      transition: 'color 0.2s ease-out',
      color: ({ buttonTheme: { color } }) => color,
      ...(detectIt.primaryInput === 'touch'
        ? {
          '$selected&': {
            color: 'currentColor',
          },
        } : {
          '$selected&,&:hover,&:focus': {
            color: 'currentColor',
          },
        }),
    }),
    '&.largePadding': {
      padding: [8, 16],
      '&::after': {
        left: 16,
        right: 16,
      },
    },
  },
  selected: {
    '&::after': {
      borderBottom: ({ buttonTheme: { selected } }) => `3px solid ${selected}`,
    },
  },
})(Button);
